<button
  class="d-flex justify-content-center align-items-center rounded-4 bg-content-secondary" id="btn-regresar"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1665 8.00023C15.1665 8.3609 14.8605 8.66683 14.4998 8.66683L4.06314 8.66683L7.80516 12.3953C8.0602 12.6503 8.0602 13.0638 7.80516 13.3189C7.55013 13.5739 7.13663 13.5739 6.88159 13.3189L2.02445 8.46173C1.76942 8.2067 1.76942 7.7932 2.02445 7.53817L6.88159 2.68102C7.13663 2.42599 7.55013 2.42599 7.80516 2.68102C8.0602 2.93606 8.0602 3.34955 7.80516 3.60459L4.06258 7.3335L14.4998 7.3335C14.8605 7.3335 15.1665 7.63955 15.1665 8.00023Z"
    fill="white"/>
  </svg>
</button>
